var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScratchLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 35,
    viewBox: "0 0 82 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_44934",
    "data-name": "\\u7EC4 44934",
    transform: "translate(-284.297 -1099.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_36982",
    "data-name": "\\u8DEF\\u5F84 36982",
    className: "cls-1",
    d: "M70.674,27.5a6.806,6.806,0,1,0,6.807,6.806A6.814,6.814,0,0,0,70.674,27.5m0,10.479a3.672,3.672,0,1,1,3.673-3.673,3.677,3.677,0,0,1-3.673,3.673",
    transform: "translate(284.829 1093.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_36983",
    "data-name": "\\u8DEF\\u5F84 36983",
    className: "cls-1",
    d: "M27.564,22.3a6.033,6.033,0,0,0,3.673-1.28v1h3.134V15.494A6.807,6.807,0,1,0,27.564,22.3m0-10.479a3.673,3.673,0,1,1-3.673,3.673,3.677,3.677,0,0,1,3.673-3.673",
    transform: "translate(284.46 1094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_36984",
    "data-name": "\\u8DEF\\u5F84 36984",
    className: "cls-1",
    d: "M57.92,22.025V15.493A6.807,6.807,0,1,0,51.113,22.3a6.028,6.028,0,0,0,3.673-1.281v1.006Zm-6.807-2.859a3.673,3.673,0,1,1,3.673-3.673,3.678,3.678,0,0,1-3.673,3.673",
    transform: "translate(284.644 1094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_36985",
    "data-name": "\\u8DEF\\u5F84 36985",
    className: "cls-1",
    d: "M74.661,8.687a6.806,6.806,0,1,0,0,13.613,6.028,6.028,0,0,0,3.673-1.281v1.006h3.134V15.493a6.814,6.814,0,0,0-6.807-6.806m0,10.479a3.673,3.673,0,1,1,3.673-3.673,3.678,3.678,0,0,1-3.673,3.673",
    transform: "translate(284.829 1094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_36986",
    "data-name": "\\u8DEF\\u5F84 36986",
    className: "cls-1",
    d: "M12.174,33.1a20.832,20.832,0,0,1-2.236-.741c-.815-.288-1.213-1.122-.632-1.741a2.883,2.883,0,0,1,4.069.807l2.11-1.675a5.46,5.46,0,0,0-5.417-2.367c-4.382.5-5.372,6.139-1.2,7.586,1.27.441,2.52.535,3.449,1.281a1.316,1.316,0,0,1-1.063,2.205,3.768,3.768,0,0,1-3.476-1.838l-2,1.817c1.935,3.31,7.943,3.851,9.74.336,1.222-2.865-.613-4.94-3.34-5.67",
    transform: "translate(284.297 1093.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_36987",
    "data-name": "\\u8DEF\\u5F84 36987",
    className: "cls-1",
    d: "M13.327,8.707h0a4.787,4.787,0,0,0-4.059,1.554l-.08.086-.081-.086A4.8,4.8,0,0,0,5.05,8.707a5.324,5.324,0,0,0-3.582,1.627,5.527,5.527,0,0,0-1.468,4v7.655H3.164V14.154a2.709,2.709,0,0,1,.591-1.815,1.735,1.735,0,0,1,1.438-.67,2.49,2.49,0,0,1,1.719.645,1.843,1.843,0,0,1,.682,1.5v8.181h3.185V13.81a1.891,1.891,0,0,1,.662-1.5,2.571,2.571,0,0,1,1.738-.645,1.777,1.777,0,0,1,1.459.67,2.779,2.779,0,0,1,.613,1.815v7.837h3.163V14.336a5.526,5.526,0,0,0-1.487-4,5.44,5.44,0,0,0-3.6-1.629",
    transform: "translate(284.297 1094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_36988",
    "data-name": "\\u8DEF\\u5F84 36988",
    className: "cls-1",
    d: "M35.382,35.309a2.656,2.656,0,0,1-.858,1.969,2.717,2.717,0,0,1-1.975.819,2.76,2.76,0,0,1-1.986-.81,2.624,2.624,0,0,1-.847-1.978V27.8H26.594v7.331A5.9,5.9,0,0,0,28.275,39.4a5.816,5.816,0,0,0,4.274,1.723A5.719,5.719,0,0,0,36.8,39.4a5.834,5.834,0,0,0,1.7-4.272V27.8H35.382Z",
    transform: "translate(284.5 1093.62)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62_5685",
    "data-name": "\\u77E9\\u5F62 5685",
    className: "cls-1",
    width: 3.082,
    height: 11.367,
    transform: "translate(342.561 1123.092)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_36989",
    "data-name": "\\u8DEF\\u5F84 36989",
    className: "cls-1",
    d: "M59.411,24.1a1.846,1.846,0,1,0,1.883,1.846A1.867,1.867,0,0,0,59.411,24.1",
    transform: "translate(284.691 1093.782)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_36990",
    "data-name": "\\u8DEF\\u5F84 36990",
    className: "cls-1",
    d: "M54.526,24.559H51.4v4.086a6.762,6.762,0,0,0-3.673-1.082c-.172,0-.342.01-.511.023a6.281,6.281,0,0,0-2.944.924,6.806,6.806,0,0,0-3.351,5.86,6.933,6.933,0,0,0,.051.821A6.764,6.764,0,0,0,46.59,41.08a6.866,6.866,0,0,0,1.136.1,5.894,5.894,0,0,0,.783-.053,6.477,6.477,0,0,0,2.89-1.04V40.9h3.134V24.559ZM51.4,34.37A3.672,3.672,0,1,1,47.726,30.7,3.677,3.677,0,0,1,51.4,34.37",
    transform: "translate(284.618 1093.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_36991",
    "data-name": "\\u8DEF\\u5F84 36991",
    className: "cls-1",
    d: "M65.805,19.827a2.956,2.956,0,0,1-1.94-2.78V12.336H66.48V9.355H63.865V5.912H60.824V17.047a5.978,5.978,0,0,0,3.988,5.6Z",
    transform: "translate(284.724 1094)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_36992",
    "data-name": "\\u8DEF\\u5F84 36992",
    className: "cls-1",
    d: "M21.474,24.559H18.433V35.694a5.98,5.98,0,0,0,3.987,5.6l.994-2.818a2.956,2.956,0,0,1-1.94-2.78V30.983h2.614V28H21.474Z",
    transform: "translate(284.426 1093.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_36993",
    "data-name": "\\u8DEF\\u5F84 36993",
    className: "cls-1",
    d: "M42.036,19.827a2.956,2.956,0,0,1-1.94-2.78V12.336h2.615V9.355H40.1V5.912H37.055V17.047a5.978,5.978,0,0,0,3.988,5.6Z",
    transform: "translate(284.557 1094)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScratchLogo);
export default __webpack_public_path__ + "static/media/scratch-logo.8a9032e31a98da9626cb94b743579ef9.svg";
export { ForwardRef as ReactComponent };